module.exports = __webpack_public_path__ + "static/withoutaspect-fcca2c7d65a4e5681591601e413ae89c.png";